export default {
    row1 :[

    {
        column: "column1",
      
        rows: {
            row1: [
               {
                name: "exportAnnexDocumentName",
                label: "Document Name",
                component: "text-field",
                width:"50%",

               },
            ],  
        }
    },
    
]
    
}


